
export default function Logo(){

    return(

        <div
            className="font-bold text-2xl md:text-xl"
        >
            The <span className="text-primary">Shopkeeper <span className="accent">.</span> </span>

        </div>

    )

}

export const LogoLight = ()=>{

    return(

        <div
            className="font-bold text-2xl md:text-xl"
        >
            <span className="text-secondary">The</span> <span className="text-white" >Shopkeeper <span className="accent">.</span> </span>

        </div>

    )

}